const BASE_URL = 'https://acko-cms.ackoassets.com/'

export const RIGHT_ARROW_URL = `${BASE_URL}arrow_right_17fdfcd600.svg`
export const RIGHT_ARROW_BLUE_URL = `${BASE_URL}arrow_right_ac5f6c0dd4.svg`
export const RIGHT_CHEVRON_URL = `${BASE_URL}chevron_right_c1e7ad2149.svg`
export const PHONE_CALL_URL = `${BASE_URL}Phone_8a5a405dd3.svg`
export const CIRCLE_ARROW_URL = `${BASE_URL}circle_arrow_af96833674.svg`
export const RIGHT_ARROW_GREY_URL = `${BASE_URL}arrow_right_grey_ce55b23fa0.svg`
export const SEND_ARROW_URL = `${BASE_URL}send_button_687a063341.svg`

// BOT ANIMATION
export const BOT_ANIMATION_FALLBACK = `${BASE_URL}bota_animation_fallback_7b42c9a57a.webp`
export const BOT_BLINK_ANIMATION = {
  white: `${BASE_URL}blink_white_fcbdc00fed.webm`,
  dark: `${BASE_URL}blink_dark_68c23e08d8.webm`,
}
export const BOT_EYE_MOVEMENT_ANIMATION = {
  white: `${BASE_URL}blob_eye_movement_white_e2438cbe34.webm`,
  dark: `${BASE_URL}blob_eye_movement_dark_3b0e32fb26.webm`,
}
export const BOT_FULL_ANIMATION = {
  white: `${BASE_URL}blob_full_animation_b6a44e1a5e.webm`,
}
